import React, { HTMLAttributes, useEffect } from 'react';
import CurrencyFormat from 'react-currency-format';
import ToggleButton from '@/components/ToggleButton';
import cn from '@/utils/cn';
import { useResizeText } from '../hooks/useResizeText';
import { TWalletData } from '../types/WalletData';

const CurrencyClassName = cn(['text-emerge-navy', 'font-medium', 'text-5xl', 'leading-[54px]']);

interface AccountBalanceProps extends HTMLAttributes<HTMLDivElement> {
  selectedAccount: TWalletData;
  showAllAccounts: boolean;
  isAllAccounts: boolean;
  onShowAllAccountsToggle: () => void;
}

const AccountBalance: React.FC<AccountBalanceProps> = ({
  className,
  selectedAccount,
  isAllAccounts,
  showAllAccounts,
  onShowAllAccountsToggle
}) => {
  const { resizeText } = useResizeText();

  useEffect(() => {
    resizeText({
      element: document.getElementById('currency')!,
      parent: document.getElementById('account-container')!
    });
  }, [selectedAccount.balance]);

  return (
    <div
      id="account-container"
      className={cn('flex flex-col gap-y-4 w-[456px] min-w-[456px] max-w-[456px]', className)}>
      <div className={cn('flex flex-col')}>
        <h4 className="text-emerge-navy-2 text-sm font-medium">
          {isAllAccounts ? 'Total balance' : 'Account balance'}
        </h4>
        <CurrencyFormat
          id="currency"
          className={CurrencyClassName}
          value={Number(selectedAccount.balance).toFixed(2)}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
          decimalScale={2}
        />
      </div>
      <div>
        <ToggleButton
          name="show-all-accounts"
          toggleState={showAllAccounts}
          onChange={onShowAllAccountsToggle}
          label={<span className="text-xs font-medium text-emerge-navy">Show all accounts</span>}
        />
      </div>
    </div>
  );
};

export default AccountBalance;
